
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, Edit, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Company } from '@/lib/types';

interface CompanyQuickActionsProps {
  company: Company;
  isAdmin: boolean;
  isActiveCompany: boolean;
  onSetActiveCompany: () => void;
}

const CompanyQuickActions = ({
  company,
  isAdmin,
  isActiveCompany,
  onSetActiveCompany
}: CompanyQuickActionsProps) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {!isActiveCompany && (
          <Button className="w-full justify-start" variant="default" onClick={onSetActiveCompany}>
            <Briefcase className="h-4 w-4 mr-2" />
            Set as Active Company
          </Button>
        )}
        {isAdmin && (
          <Button className="w-full justify-start" variant="outline" onClick={() => navigate(`/companies/${company.id}/edit`)}>
            <Edit className="h-4 w-4 mr-2" />
            Edit Company
          </Button>
        )}
        <Button className="w-full justify-start" variant="outline">
          <Globe className="h-4 w-4 mr-2" />
          Generate Reports
        </Button>
      </CardContent>
    </Card>
  );
};

export default CompanyQuickActions;
